import { Activity, BookOpenCheck, ChevronLeft, Home, LogOut, Menu, Moon, Settings, Shield, Sun, Swords, Users, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { InstructionModal } from '../components/InstructionModal'
import { useAuth } from '../components/AuthGate'

const nav = [
  { to: '/', label: 'Главная', icon: Home }, { to: '/matches', label: 'Матчи', icon: Swords }, { to: '/squad', label: 'Состав', icon: Users },
  { to: '/tactics', label: 'Тактика', icon: Activity }, { to: '/opponents', label: 'Соперники', icon: Shield }, { to: '/settings', label: 'Настройки', icon: Settings },
]

type Theme = 'dark' | 'light'

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('ps-sidebar') === 'collapsed')
  const [mobileOpen, setMobileOpen] = useState(false)
  const [guideOpen, setGuideOpen] = useState(false)
  const [theme, setTheme] = useState<Theme>(() => localStorage.getItem('ps-theme') === 'light' ? 'light' : 'dark')
  const location = useLocation()
  const { logout } = useAuth()

  useEffect(() => { document.documentElement.dataset.theme = theme }, [theme])

  const toggleSidebar = () => setCollapsed(value => {
    localStorage.setItem('ps-sidebar', !value ? 'collapsed' : 'open')
    return !value
  })
  const toggleTheme = () => setTheme(current => {
    const next = current === 'dark' ? 'light' : 'dark'
    localStorage.setItem('ps-theme', next)
    return next
  })

  return <div className={`app-shell ${collapsed ? 'is-collapsed' : ''}`}>
    <button className="mobile-menu-button" onClick={() => setMobileOpen(true)} aria-label="Открыть меню"><Menu/></button>
    <aside className={`sidebar ${mobileOpen ? 'is-open' : ''}`}>
      <button className="mobile-close icon-button" onClick={() => setMobileOpen(false)} aria-label="Закрыть меню"><X/></button>
      <div className="brand"><img src="/assets/prime-squad-logo.png" alt="PRIME SQUAD"/><div><strong>PRIME HUB</strong></div></div>
      <nav aria-label="Основная навигация">{nav.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} end={to === '/'} onClick={() => setMobileOpen(false)} title={collapsed ? label : undefined} className={({ isActive }) => isActive ? 'active' : ''}><Icon/><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-spacer"/>
      <button className="theme-button" onClick={toggleTheme} title={collapsed ? (theme === 'dark' ? 'Светлая тема' : 'Тёмная тема') : undefined}>{theme === 'dark' ? <Sun/> : <Moon/>}<span>{theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}</span></button>
      <button className="theme-button" onClick={() => void logout()} title={collapsed ? 'Выйти' : undefined}><LogOut/><span>Выйти из хаба</span></button>
      <button className="collapse-button" onClick={toggleSidebar}><ChevronLeft/><span>Свернуть меню</span></button>
    </aside>
    {mobileOpen && <button className="mobile-overlay" aria-label="Закрыть меню" onClick={() => setMobileOpen(false)}/>} 
    <main key={location.pathname}>
      <div className="top-strip"><button className="instruction-button" onClick={() => setGuideOpen(true)}><BookOpenCheck/>Инструкция</button></div>
      <div className="page-container"><Outlet/></div>
      <InstructionModal open={guideOpen} onClose={() => setGuideOpen(false)}/>
    </main>
  </div>
}
